import React from 'react'
import ReactDOM from 'react-dom/client'
import UserApp from './App.tsx'
import '../../index.css'
// i18n 초기화 — 화면이 그려지기 전에 언어가 정해져야 한다
import '../../shared/i18n/config'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <UserApp />
  </React.StrictMode>
)
